var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageObservable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590.237,
    height: 662.878,
    viewBox: "0 0 590.237 662.878",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F1FA",
    fillRule: "nonzero",
    y: 368,
    width: 390,
    height: 294.878,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h374a8 8 0 018 8v278.878a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
    fill: "#272729",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.805 78.74H355.65"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.195,
    cy: 79.268,
    r: 5.285
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.805 154.837H355.65"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.195,
    cy: 155.366,
    r: 5.285
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.805 230.935H355.65m-242.032 0v4.228m87.723-4.228v4.228m89.838-4.228v4.228"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.195,
    cy: 231.463,
    r: 5.285
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EE5622",
    fillRule: "nonzero",
    cx: 22.195,
    cy: 272.683,
    r: 5.285
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 35.935,
    y: 269.512,
    width: 31.707,
    height: 8.455,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 16.911,
    y: 46.504,
    width: 209.268,
    height: 8.455,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 16.911,
    y: 16.911,
    width: 289.593,
    height: 16.911,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 186.016,
    y: 247.317,
    width: 31.707,
    height: 8.455,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 97.236,
    y: 247.317,
    width: 31.707,
    height: 8.455,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 274.797,
    y: 247.317,
    width: 31.707,
    height: 8.455,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 370.976,
    cy: 19.024,
    r: 2.114
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 370.976,
    cy: 27.48,
    r: 2.114
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 370.976,
    cy: 35.935,
    r: 2.114
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    fill: "#EE5622",
    fillRule: "nonzero",
    d: "M44.919 164.878l9.967-14.797 5.862-21.138 11.726 5.285 7.036 71.87 11.725-126.83 5.863 102.52 8.794-62.357 17.59 41.22 8.793-17.968 8.208 53.374 18.762-19.553 8.208 34.35 14.657-4.756 5.863-60.773 10.553 4.756 4.104 31.708 9.38 3.17 9.38 29.065 5.864-49.146 18.175 20.081 2.931-8.455 11.14 12.155 6.449-6.87 10.553-57.602 7.621-21.667 8.208 86.139 9.967 7.398h7.036l10.553 10.04 14.07-29.593 21.693-15.854v68.7H44.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.919 164.878l9.967-14.797 5.862-21.138 11.726 5.285 7.036 71.87 11.725-126.83 5.863 102.52 8.794-62.357 17.59 41.22 8.793-17.968 8.208 53.374 18.762-19.553 8.208 34.35 14.657-4.756 5.863-60.773 10.553 4.756 4.104 31.708 9.38 3.17 9.38 29.065 5.864-49.146 18.175 20.081 2.931-8.455 11.14 12.155 6.449-6.87 10.553-57.602 7.621-21.667 8.208 86.139 9.967 7.398h7.036l10.553 10.04 14.07-29.593 21.693-15.854",
    stroke: "#EE5622",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#E8F1FA",
    fillRule: "nonzero",
    x: 183.424,
    y: 33.814,
    width: 390,
    height: 294.878,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.999 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h374.239a8 8 0 018 8v278.69a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
    fill: "#272729",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.771 78.953h312.743"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.63,
    cy: 78.953,
    r: 5.532
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.771 154.386h312.743"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.63,
    cy: 155.391,
    r: 5.532
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M42.771 230.824h312.743m-241.359.503v4.023m87.502-4.023v4.023m89.513-4.023v4.023"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#444",
    cx: 22.63,
    cy: 231.83,
    r: 5.532
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FDD9D",
    fillRule: "nonzero",
    cx: 22.63,
    cy: 273.066,
    r: 5.532
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1976D2",
    fillRule: "nonzero",
    cx: 90.016,
    cy: 273.066,
    r: 5.532
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.288 229.315l15.876-39.602H74.1l1.588-5.808h7.408l24.342-25.873h18.52l2.646-6.337h16.934v-5.28h33.866l3.705-4.752H201.1l2.646 4.752 3.704-4.752h7.938l1.587 4.752h6.88l4.762-4.752h4.233l4.763 6.864 5.82-6.864h19.05l14.288-15.313h17.992l24.342-25.874 5.82-1.584 2.647-5.28 5.82 2.64 3.705-5.808h13.229l3.704-8.977",
    stroke: "#5FDD9D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.277 205.208l23.755-6.934h16.893l6.335-3.734 10.03 3.734 4.223-3.734 10.558 5.334 13.198-5.334 24.811 5.334 15.837-5.334 20.588-2.133 5.28 5.867 5.806-8.534 6.863 4.8 4.223-7.467h12.67l6.334 7.467h11.086l4.223 3.734 15.31-8.534h7.39l7.39 4.8 20.06 3.734 8.975-8.534 15.837 2.667 6.335 27.201 11.614 2.667 12.141-15.467",
    stroke: "#1976D2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 36.208,
    y: 269.546,
    width: 32.185,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 103.594,
    y: 269.546,
    width: 32.185,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 17.098,
    y: 46.265,
    width: 209.2,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 17.098,
    y: 17.098,
    width: 289.662,
    height: 17.098,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 186.067,
    y: 247.419,
    width: 32.185,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 97.56,
    y: 247.419,
    width: 32.185,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#444",
    x: 274.575,
    y: 247.419,
    width: 32.185,
    height: 8.046,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 371.129,
    cy: 19.11,
    r: 2.012
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 371.129,
    cy: 27.156,
    r: 2.012
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#D8D8D8",
    cx: 371.129,
    cy: 36.208,
    r: 2.012
  })))));
}

export default SvgImageObservable;